import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Twitter, Instagram, Youtube } from "lucide-react";
import { LOGO_URL, BRAND } from "../lib/mockData";

const COLS = [
  { title: "Innovators",   items: [["Submit innovation", "/submit"], ["Find attorneys", "/attorneys"], ["Pricing", "/pricing"], ["Concierge", "/concierge"]] },
  { title: "Attorneys",    items: [["Join the marketplace", "/attorneys/premium"], ["Premium profile", "/attorneys/premium"], ["Partner programme", "/enterprise"], ["Resources", "/contact"]] },
  { title: "Company",      items: [["About Udhyak", "/contact"], ["Enterprise", "/enterprise"], ["Press", "/contact"], ["Careers", "/contact"], ["Contact", "/contact"]] },
];

export default function Footer() {
  return (
    <footer className="bg-[#0A2520] text-white pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-14 w-14 rounded-xl bg-gradient-to-br from-[#0E6E5E] to-[#0A3B36] flex items-center justify-center ring-1 ring-white/10 shadow-lg">
                <span className="font-display font-black text-3xl text-[#7CC242] leading-none">U</span>
              </div>
              <div>
                <div className="font-display font-extrabold text-2xl">{BRAND.name}</div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-[#7CC242] mt-1 font-semibold">Securing Ideas · Nurturing Success</div>
              </div>
            </div>
            <p className="text-sm text-white/60 leading-relaxed max-w-sm mb-6">
              India's most trusted IP marketplace. Connecting innovators with 850+ certified patent attorneys
              for end-to-end filing, prosecution, and grant support — PAN India.
            </p>
            <div className="space-y-2.5 text-sm text-white/70">
              <a href={`tel:${BRAND.phone}`} className="flex items-center gap-2.5 hover:text-[#7CC242]">
                <Phone size={14} className="text-[#7CC242]" /> {BRAND.phone}
              </a>
              <a href={`mailto:${BRAND.email}`} className="flex items-center gap-2.5 hover:text-[#7CC242]">
                <Mail size={14} className="text-[#7CC242]" /> {BRAND.email}
              </a>
              <div className="flex items-start gap-2.5">
                <MapPin size={14} className="text-[#7CC242] mt-0.5 flex-shrink-0" />
                <span>Offices in New Delhi · Mumbai · Bengaluru</span>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-6">
              {[Linkedin, Twitter, Instagram, Youtube].map((Icon, i) => (
                <a key={i} className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#0E6E5E] flex items-center justify-center transition cursor-pointer">
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title}>
              <div className="font-display font-bold text-sm uppercase tracking-widest text-[#7CC242] mb-4">{col.title}</div>
              <ul className="space-y-2.5 text-sm text-white/70">
                {col.items.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="hover:text-[#7CC242] transition">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-6 border-t border-white/10 text-xs text-white/40 flex justify-between flex-wrap gap-4">
          <div>© 2025 Udhyak Technologies Pvt Ltd · CIN {BRAND.cin}</div>
          <div className="flex gap-5">
            <span className="hover:text-[#7CC242] cursor-pointer">Privacy</span>
            <span className="hover:text-[#7CC242] cursor-pointer">Terms</span>
            <span className="hover:text-[#7CC242] cursor-pointer">Disclaimer</span>
            <span className="hover:text-[#7CC242] cursor-pointer">Sitemap</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
